export default __webpack_public_path__ + "static/media/cap60-home-2.527aee12.jpeg";